export const PERSONA_API_FF = 'prebooking_homescreen_persona_api';
export const EARLY_TENURE_FF = 'prebooking_early_tenure';
export const ABANDON_CART_FF = 'prebooking_abandon_cart';
export const VACATION_RENTALS_FF = 'vr_prebooking_enabled_FF';
export const DISABLE_PACKAGES_FF = 'prebooking_packages_tab_disabled';
export const HOMEPAGE_REDESIGN_EXPERIMENT = 'prebooking_hp_search_widget_redesign';
export const GET_INSPIRED_FF = 'prebooking_get_inspired';
export const DISPLAY_E_TICKET_BANNER = 'prebooking_e-ticket_banner';
